import { useCallback } from "react";

import { useLocation } from "react-router";

import { EntityType } from "@mapmycustomers/shared/enum";

import RecordPaneTab from "@app/enum/preview/RecordPaneTab";
import { showEntityView } from "@app/store/entityView/actions";

const useInitializePreviewEntity = (showEntityViewAction: typeof showEntityView) => {
  const { search } = useLocation();

  return useCallback(() => {
    // process incoming url params
    if (search) {
      const urlParams = new URLSearchParams(search);
      const previewEntityType = urlParams.get("previewEntityType");
      const previewEntityId = urlParams.get("previewEntityId");
      const previewEntityTab = (urlParams.get("previewEntityTab") ?? undefined) as
        | RecordPaneTab
        | undefined;
      if (previewEntityType && previewEntityId) {
        showEntityViewAction({
          entityId: parseInt(previewEntityId, 10),
          entityType: previewEntityType as EntityType,
          focusOnPin: true,
          tab: previewEntityTab,
        });
        urlParams.delete("previewEntityType");
        urlParams.delete("previewEntityId");
        urlParams.delete("previewEntityTab");
        window.history.replaceState(
          {},
          document.title,
          `${window.location.origin}${window.location.pathname}?${urlParams.toString()}${
            window.location.hash
          }`
        );
      }
    }
  }, [showEntityViewAction, search]);
};

export default useInitializePreviewEntity;
